<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <!-- <div class="grid sm:flex gap-3 mt-2 sm:flex-wrap">
      <div class="mt-2 report-box-2" :class="data.icon != 'sensitive' ? 'flex-1' : 'flex-1-5'" v-for="(data, key) in countCard" :key="key">
        <div class="box bg-white h-full">
          <div class="px-4 py-4 flex flex-col justify-center flex-1">
            <div class="flex items-center justify-between">
              <h3 class="font-bold text-primary-1 text-base">{{data.text}}</h3>

              <span
                class="
                  w-8
                  h-8
                  px-2
                  py-2
                  flex
                  items-center
                  justify-center
                  rounded-full
                  border-1
                  text-theme-17
                  ml-2
                  box-shadow
                "
              >
                <HomeIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'house'"
                />
                <UsersIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'family'"
                />
                <UserIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'member'"
                />
                <FrownIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'sensitive'"
                />
              </span>
            </div>

            <div class="relative text-5xl font-medium ml-0.5 mt-2 flex text-primary-1" v-if="data.icon != 'sensitive'">
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">บันทึก</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.approve_count}}</div>
              </div>
              <div class="left text-sm flex-1 text-center">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">อนุมัติ</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.reject_count}}</div>
              </div>
            </div>
            <div class="relative text-5xl font-medium ml-0.5 mt-2 flex text-primary-1" v-else>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">0</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_0}}</div>
              </div>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">1</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_1}}</div>
              </div>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">2</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_2}}</div>
              </div>
              <div class="left text-sm flex-1 text-center">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">3</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_3}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <h2 class="text-lg mb-2 mt-5">รายงานสรุปปัญหา</h2>
    <DataTreeTable
      :api-params="paramsComputed"
      :api-url="'household/getHouseSurveySummaryReport/'"
      :method-request="'POST'"
      :data-array-table="dataArrayTable"
      :key="key"
      :table-name="'report'"
      :default-sort="[{field:'_id',dir:'asc'}]"
      :custom-sort="[{column: 'head_name', relateColumn: ['head_surname']}]"
      :downloadCsv="downloadCsv"
      @downloadCsvComplete="$emit('downloadCsvComplete')"
      :downloadExcel="downloadExcel"
      @downloadExcelComplete="$emit('downloadExcelComplete')"
      reportName="รายงานสรุปปัญหา"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
import DataTreeTable from "@/components/datatable/dataTreeDataTable.vue"

export default defineComponent({
  props:{
    filter:{
        type: Object
    },
    downloadCsv:{
      type: Boolean
    },
    downloadExcel:{
      type: Boolean
    }
  },
  components:{
    DataTreeTable
  },
  setup(props) {
    const params = ref({start: '1',draw: '1',length: '10'})
    const key = ref(1)
    watch(()=>props.filter, ()=>{
      key.value++
    })
    const paramsComputed = computed(() => ({...params.value, ...props.filter}))
    var customNameMutator = (value, data, type, params, component) => {
      // if(data.cm_uid){
      //   return data.cm_uid;
      // }else{
      return `${data.head_title ? data.head_title : ""}${data.head_name ? data.head_name: ""} ${data.head_surname ? data.head_surname : ""}`
      // }
    }
    var customAddressMutator = (value, data, type, params, component) => {
      return `${data.hnum ? data.hnum:""} ${data.moo?'หมู่ '+data.moo:""} ${data.village_name?data.village_name: ""} ${data.soi?'ซอย '+data.soi: ""} ${data.road?'ถนน '+data.road: ""}`
    }
    /*var customProblemMutator = (value, data, type, params, component) => {
      if(data.memberinfo ? data.memberinfo.member_stats : false){
        return {"housing": data.memberinfo.member_stats.prob_housing, "health": data.memberinfo.member_stats.prob_health, "occupation": data.memberinfo.member_stats.prob_occupation, "education": data.memberinfo.member_stats.prob_education, "accessibility": data.memberinfo.member_stats.prob_accessibility}
      }else{
        return {"housing": 0, "health": 0, "occupation": 0, "education": 0, "accessibility": 0}
      }
    } */
    const dataArrayTable = reactive([
      {title:"หัวหน้าครัวเรือน", field:"head_name", minWidth: 230, width: 230, variableHeight: true, mutator: customNameMutator},
      {title:"ที่อยู่", field:"hnum", minWidth: 230, width: 230, resizable:true, formatter:"textarea", mutator: customAddressMutator},
      {title:"ท้องถิ่นเทศบาล", field:"local", minWidth: 130, width: 130, resizable:true, formatter:"textarea"},
      {title:"ตำบล", field:"tumbol_name", minWidth: 130, width: 130, resizable:true, formatter:"textarea"},
      {title:"อำเภอ", field:"amphur_name", minWidth: 130, width: 130, resizable:true, formatter:"textarea"},
      {title:"จังหวัด", field:"province_name", minWidth: 130, width: 130, resizable:true, formatter:"textarea"},
      {title:"ประเภทครัวเรือน", field:"hh_type", minWidth: 150, width: 150, resizable:true, formatter:"textarea"},
      {title:"จำนวนครอบครัว", field:"fam_cnt", hozAlign:"center", minWidth: 120, width: 120, resizable:true, formatter:
        function(cell, formatterParams){
          return cell.getValue() ? cell.getValue() : 0
        }
      },
      {title:"จำนวนสมาชิก", field:"member_cnt", hozAlign:"center", resizable:true, minWidth: 120, width: 120, 
        formatter:function(cell, formatterParams){
          return cell.getValue() ? cell.getValue() : 0
        }
      },
      {//create column group
        title:"จำนวนคนที่ประสบปัญหา/ต้องการพัฒนาคุณภาพชีวิต",
        columns:[
          {title:"สุขภาพ", field:"prob_health", hozAlign:"right", width:100, hozAlign:"center", headerSort:false, titleDownload: "จำนวนคนที่ประสบปัญหาสุขภาพ", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"ความเป็นอยู่", field:"prob_family", hozAlign:"right", width:120, hozAlign:"center", headerSort:false, titleDownload: "จำนวนคนที่ประสบปัญหาความเป็นอยู่", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"การศึกษา", field:"prob_education", hozAlign:"right", width:100, hozAlign:"center", headerSort:false, titleDownload: "จำนวนคนที่ประสบปัญหาการศึกษา", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"รายได้", field:"prob_occupation", hozAlign:"right", width:100, hozAlign:"center", headerSort:false, titleDownload: "จำนวนคนที่ประสบปัญหารายได้", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"การเข้าถึงบริการภาครัฐ", field:"prob_accesibility", hozAlign:"right", width:155, hozAlign:"center", titleDownload: "จำนวนคนที่ประสบปัญหาการเข้าถึงบริการภาครัฐ", headerSort:false, formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
        ],
      },
    ])
    const countCard = reactive([
      {
        text: "จำนวนครัวเรือน",
        approve_count: 28,
        reject_count: 28,
        icon: "house",
      },
      {
        text: "จำนวนครอบครัว",
        approve_count: 28,
        reject_count: 28,
        icon: "family",
      },
      {
        text: "จำนวนสมาชิก",
        approve_count: 28,
        reject_count: 28,
        icon: "member",
      },
      {
        text: "จำนวนความเปราะบาง",
        level_0: 28,
        level_1: 28,
        level_2: 28,
        level_3: 28,
        icon: "sensitive",
      },
    ]);

    return {
      dataArrayTable,
      countCard,
      paramsComputed,
      key
    }
  }
})
</script>
<style lang="scss">
/*#tree-tabulator.tabulator{
  .tabulator-tree-level-0 [tabulator-field="household_count"],
  .tabulator-tree-level-0 [tabulator-field="family_count"],
  .tabulator-tree-level-0 [tabulator-field="member_count"],
  .tabulator-tree-level-0 [tabulator-field="sensitive_level_count"] {
    text-align: center !important;
    justify-content: center !important;
  }
}*/
.flex-1-5{
  flex: 1.5;
}
</style>

